import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/navData";

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/92 backdrop-blur-md border-b border-background-200"
          : "bg-background-50 border-b border-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-6 h-16 flex items-center justify-between gap-4">
        <a href="#top" className="flex items-center gap-3 cursor-pointer shrink-0">
          <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
            51
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg font-semibold text-foreground-950 whitespace-nowrap">
              51网址导航
            </span>
            <span className="text-[11px] text-foreground-500 tracking-wide whitespace-nowrap">
              分类收录 · 挑站更省心
            </span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#sites"
            className="flex items-center gap-2 px-4 py-2 rounded-md text-sm text-foreground-800 border border-background-300 hover:border-foreground-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-search-line"></i>
            搜站点
          </a>
          <a
            href="#submit"
            className="flex items-center gap-2 px-4 py-2 rounded-md text-sm bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-add-circle-line"></i>
            收录申请
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-3 px-2 py-3 rounded-md text-sm text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <i className={`${link.icon} text-lg text-primary-600`}></i>
                {link.label}
              </a>
            ))}
          </nav>
          <a
            href="#submit"
            onClick={() => setMenuOpen(false)}
            className="mt-2 flex items-center justify-center gap-2 w-full px-4 py-3 rounded-md text-sm bg-primary-500 text-background-50 cursor-pointer"
          >
            <i className="ri-add-circle-line"></i>
            收录申请
          </a>
        </div>
      )}
    </header>
  );
}